// Подпись поля: shadcn 4.21.1 (base-mira), подогнана под ui-spec §4 (задача D4): 12/16, насыщенность 500, над полем.
import { cn } from 'cn';
import type * as React from 'react';

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    // oxlint-disable-next-line jsx-a11y/label-has-associated-control -- связь с полем задаёт вызывающий: htmlFor или поле внутри подписи
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm font-medium text-foreground select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
